import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import PaymentInformation from '../components/PaymentInformation';
import { startFetchRequest as getBankCardsStartRequest } from 'modules/Payment/redux/bankCards/actions';
import { configSelect } from 'modules/ConfigWrapper/redux/selectors';
import { property } from 'lodash';

const mapStateToProps = createStructuredSelector({
  configData: configSelect,
  bankCards: property('payment.bankCards.data'),
  isCardsLoading: property('payment.bankCards.loading'),
  isCardsError: property('payment.bankCards.error'),
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getBankCards: getBankCardsStartRequest,
    },
    dispatch,
  );
export default connect(mapStateToProps, mapDispatchToProps)(PaymentInformation);
